/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

// It's setting the more or less distance from the bottom of the mock browser to the bottom of the screen.
// Don't set the value too low, or the mock browser size will be extending to infinity on small widths.
export const PADDING_BOTTOM = 270;
